import { __rest } from "tslib";
import * as React from 'react';
import { useField } from 'formik';
import { CheckboxContainer, Container, Label, StyledCheckbox, SupportText, TextContainer, ToggleCircle } from './Switch.styled';
import { Icon } from '../../icon';
import { theme } from '../../../theme';
export const SwitchField = (props) => {
    const [field] = useField(Object.assign(Object.assign({}, props), { type: 'checkbox' }));
    const [focussed, setFocussed] = React.useState(false);
    return (React.createElement(CheckboxContainer, { toggled: !!field.checked, focussed: focussed, toggledColor: props.toggledColor },
        React.createElement(StyledCheckbox, Object.assign({ "data-testid": `switch-checkbox-${props.name}`, type: "checkbox", id: props.name, "aria-label": props.label }, field, props, { onFocus: () => setFocussed(true), onBlur: () => setFocussed(false) })),
        React.createElement(ToggleCircle, { className: "circle", toggled: !!field.checked }, !!field.checked && React.createElement(Icon, { name: "Checkmark", color: props.toggledColor }))));
};
export const Switch = (_a) => {
    var { label, description, name, toggledColor = theme.colors.PO110, descriptionJsxContent } = _a, otherProps = __rest(_a, ["label", "description", "name", "toggledColor", "descriptionJsxContent"]);
    return (React.createElement(Container, null,
        React.createElement(TextContainer, null,
            React.createElement(Label, { htmlFor: name }, label),
            description && React.createElement(SupportText, null, description),
            descriptionJsxContent && descriptionJsxContent),
        React.createElement(SwitchField, Object.assign({ name: name, label: label, toggledColor: toggledColor }, otherProps))));
};
//# sourceMappingURL=Switch.js.map